import { render, staticRenderFns } from "./Streamer-agora.vue?vue&type=template&id=7c1e2542&scoped=true"
import script from "./Streamer-agora.vue?vue&type=script&lang=js"
export * from "./Streamer-agora.vue?vue&type=script&lang=js"
import style0 from "./Streamer-agora.vue?vue&type=style&index=0&id=7c1e2542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1e2542",
  null
  
)

export default component.exports